module.exports = __webpack_public_path__ + "img/crossmark.08a0740c.svg";